const TRUSTPILOT = {
  totalReview: 252,
  rate: 4.4,
};

export default TRUSTPILOT;
